export default "__VITE_ASSET__66ad566f__"